import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import '@/utils/AlimamaShuHeiTi-Bold-normal.js';
export function phyToPDF(activeType, bedName, date, containerEl) {
  return new Promise((resolve, reject) => { 
    setTimeout(async () => {
      try {
        const contentContainer = containerEl || document.getElementById('reportExportPdf');
        if (!contentContainer) return;

        let pdfConfig = {
          format: 'a4', // 纸张格式
          margin: 12, // 页面边距（单位：mm）
          scale: 2, // html2canvas 缩放比例（提高清晰度）
        }
        // 1. 初始化 jsPDF 实例
        const doc = new jsPDF({
          orientation: 'portrait', // 纵向
          unit: 'mm',
          format: pdfConfig.format,
        });

        /**
         * 导入字体包，pdfjs 不支持中文识别，需要加入中文字体包才不乱码
         * 
         * 生成字体包流程
         *  1. 找相对应的.ttf文件并下载下来，目前使用 AlimamaShuHeiTi-Bold-normal.ttf
         *  2. 打开 assets/pfdztb 文件夹下的 fontconverter.html
         *  3. fontStyle 下拉选择 normal、Module format下拉选项选择 UMD、File 为第一步下载的.ttf文件
         *  4. 最后点击 create 生成 pdf 兼容中的 js 库，将js库保存到项目中并引入（如目前引用的是/utils/AlimamaShuHeiTi-Bold-normal.js文件）
         *  5. 点击项目中的 js 文件 并按以下代码对比进行引入
         */
        doc.addFont('AlimamaShuHeiTi-Bold-normal.ttf', 'AlimamaShuHeiTi-Bold', 'normal'); // 字体名称是 MyFont
        doc.setFont('AlimamaShuHeiTi-Bold');

        // 2. 计算 PDF 页面的可用尺寸（转换为 px，1mm ≈ 3.78px）
        const pageWidthMm = doc.internal.pageSize.getWidth() - 2 * pdfConfig.margin;
        const pageHeightMm = doc.internal.pageSize.getHeight() - 2 * pdfConfig.margin;
        const pageWidthPx = pageWidthMm * 3.78;
        // 界面元素 px 为A4纸的3.78倍，但是高按3.78留白太大，目前定义高为4倍，后边如有截断或显示不全，需将高调至 3.78
        const pageHeightPx = pageHeightMm * 3.85;

        // 3. 获取 ECharts 渲染的 Canvas 元  素，并将dom节点中的 Canvas 转为图片
        const canvasArs = contentContainer.querySelectorAll('canvas');
        for(let i = 0; i < canvasArs.length; i++) {
          const canvas = canvasArs[i];
          
          if (canvas) {
            const imgData = canvas.toDataURL('image/png');
            const img = new Image();
            img.src = imgData;
            img.style.width = '100%'; // 确保图片宽度与容器一致
            img.style.height = canvas.style.height;
            const parentNode = canvas.parentNode;
            // 用 <img> 元素替换掉原来的 <canvas> 元素
            parentNode.replaceChild(img, canvas);
          }
        }

        let items = [];
        if(activeType == 1) {
          // 针对睡眠指标添加边框
          const smzbDom = contentContainer.querySelector('.leCont');
          if(smzbDom) {
            smzbDom.style.border = '1px solid #e8eaed';
          }
          // 4. 获取流式布局方框前边的 dom 节点
          let topimgDomArs = [];
          const domToImageArs = contentContainer.querySelectorAll('.no-break-to-imaged-top');
          for(let i = 0; i < domToImageArs.length; i++) {
            let domToImage = domToImageArs[i];
            const domCan = await html2canvas(domToImage, {
              scale: 2,
              width: domToImage.offsetWidth,
              height: domToImage.offsetHeight,
              useCORS: true,
              logging: false,
              ignoreElements: function(element) { 
                const style = window.getComputedStyle(element);
                return style.visibility == 'hidden' || element.classList.contains('topright');
              }
            });

            // toBlob() 是异步操作，返回一个 Promise
            const blob = await new Promise((resolve) => {
              // 'image/png' 是图片格式，也可以是 'image/jpeg' 等
              // 第三个参数是质量，仅对 jpeg 有效，范围 0-1
              domCan.toBlob(resolve, 'image/png', 1.0); 
            });

            // 3. 为 Blob 对象创建一个临时的 URL
            const imageUrl = URL.createObjectURL(blob);
            const img = new Image();
            img.src = imageUrl;
            img.style.width = '100%';
            img.style.height = 'auto';
            img.style.marginTop = '12px';
            topimgDomArs.push(img);
          }

          // 5. 获取流式布局方框后边的 dom 节点
          let bottomimgDomArs = [];
          const domBoImageArs = contentContainer.querySelectorAll('.no-break-to-imaged-bottom');
          for(let i = 0; i < domBoImageArs.length; i++) { 
            let domBoImage = domBoImageArs[i];
            // 修改呼吸详情样式，针对呼吸详情中的卡片，pdf到导出时添加边框
            const hxyczsDom = domBoImage.querySelectorAll('.comment-details-item-box');
            if(hxyczsDom&&hxyczsDom.length) {
              for(let j = 0; j < hxyczsDom.length; j++) {
                let jEle = hxyczsDom[j];
                jEle.style.width = '420px';
                // jEle.style.minHeight = '418px';
                jEle.style.border = '1px solid #e8eaed';
              }
            }

            // 获取指定的节点添加内边距，目前用于睡眠详情echars图表添加内边距
            const echarsEleDom = domBoImage.querySelectorAll('.no-break-card-echars-padd'); 
            echarsEleDom.forEach(el => { el.style.paddingTop = '10px'; });

            const domCan = await html2canvas(domBoImage, {
              scale: 2,
              width: domBoImage.offsetWidth,
              height: domBoImage.offsetHeight,
              useCORS: true,
              logging: false,
              ignoreElements: function(element) { 
                const style = window.getComputedStyle(element);
                return style.visibility == 'hidden' || element.classList.contains('topright');
              }
            });
            const blob = await new Promise((resolve) => {
              // 'image/png' 是图片格式，也可以是 'image/jpeg' 等
              // 第三个参数是质量，仅对 jpeg 有效，范围 0-1
              domCan.toBlob(resolve, 'image/png', 1.0); 
            });
            const imageUrl = URL.createObjectURL(blob);
            const img = new Image();
            img.src = imageUrl;
            img.style.width = '100%';
            img.style.height = 'auto';
            img.style.marginTop = '12px';
            bottomimgDomArs.push(img);
          }

          // 6. 克隆 DOM 容器（避免修改原 DOM）获取流式样式dom节点
          await convertClassToInlineStyles(contentContainer)
          const clonedContainer = contentContainer.cloneNode(true);
          items = Array.from(clonedContainer.querySelectorAll('.no-break-card'));
          if(items&&items.length>0) {
            items[0].style.marginTop = '8px';
          }

          // 修改流式框开头红色感叹号图片位置样式
          const redIcon = clonedContainer.querySelectorAll('.details-title-ic-img');
          if(redIcon&&redIcon.length) {
            redIcon.forEach(el => { el.style.marginTop = '15px'; });
          }

          // 7. 获取流式盒子的元素并定义盒子宽度，将整个界面撑起来，使每个盒子的宽度都为界面的宽度，取消弹性盒子排列
          const elementsToResize1 = clonedContainer.querySelectorAll('.no-break-card, .comment-details-item');
          elementsToResize1.forEach(el => {
            // 设置所获取流式dom的宽度，单位为 px
            el.style.width = 'auto';
            el.style.marginTop = '12px';
          });

          // 获取流式盒子的元素并定义盒子宽度，将整个界面撑起来，使每个盒子的宽度都为界面的宽度，取消弹性盒子排列，并且调整边距
          const elementsToResize2 = clonedContainer.querySelectorAll('.comment-details-item-box');
          elementsToResize2.forEach(el => {
            // 设置所获取流式dom的宽度，单位为 px
            el.style.width = 'auto';
            el.style.padding = '0px 12px 12px 12px';
            el.style.marginTop = '12px';
          });
          
          // 8. 创建新 div
          const newDiv = document.createElement('div');
          newDiv.className = 'no-break-card';
          items.unshift(...topimgDomArs);
          items.push(...bottomimgDomArs);
        } else {
          await convertClassToInlineStyles(contentContainer);
          const clonedContainer = contentContainer.cloneNode(true);
          const domToImageArs = clonedContainer.querySelectorAll('.no-break-to-imaged-mul');
          for(let i = 0; i < domToImageArs.length; i++) {
            let domToImage = domToImageArs[i];
            if(domToImage.innerHTML == '<!---->'||domToImage.innerHTML == '') continue;

            if((domToImage.classList.contains('nowList')&&!domToImage.classList.contains('nowList_Ques'))||domToImage.classList.contains('healthy_measure_charts_card_item')) {
              domToImage.style.border = '1px solid #e8eaed';
            }
            
            if(domToImage.classList.contains('sleepReadWrap')) {
              domToImage.style.margin = 'auto';
            }

            domToImage.style.width = '100%';
            domToImage.style.height = 'auto';
            domToImage.style.marginTop = '12px';

            // 判断是否有break-to-imaged-dt-selitem-upper属性名，如果含有则和上一个dom节点合并为一个元素用于导出pdf,用于标题不分割
            if(domToImage.classList.contains('no-break-to-imaged-dt-selitem-upper')) {
              items[items.length-1].appendChild(domToImage);
            } else {   
              const createNewDiv = document.createElement('div');
              createNewDiv.appendChild(domToImage);
              items.push(createNewDiv);
            }
          }
        }

        // 9. 拼接pdf的名称并保存 PDF
        let fileName = bedName;
        if(date) {
          if(activeType == 1) {
            fileName = `${fileName}_${date}`
          } else if(activeType == 3) {
            fileName = `${fileName}_${getDateBefore(date, 6)}~${date}`
          } else if(activeType == 4) {
            fileName = `${fileName}_${getDateBefore(date, 29)}~${date}`
          }
        }
        
        let pageTotal = 1;
        let currentPageItems = [];
        let currentPageHeight = 0;
        for (const item of items) {
          // 10. 计算元素在 PDF 中的实际高度（需等待资源加载）
          const tempDiv = createTempDiv(item, pageWidthPx);
          await waitForResources(tempDiv); // 等待图片、背景图加载
          const itemHeight = tempDiv.offsetHeight;
          document.body.removeChild(tempDiv);

          // 11. 判断是否分页
          if (currentPageHeight + itemHeight > pageHeightPx) {
            await renderPage(doc, currentPageItems, pageWidthPx, pageHeightPx, pdfConfig.margin, fileName, pageTotal);
            pageTotal = pageTotal + 1;
            currentPageItems = [];
            currentPageHeight = 0;
            doc.addPage(); // 新增一页
          }

          currentPageItems.push(item);
          currentPageHeight += (itemHeight*0.85);
        }

        // 12. 渲染最后一页
        if (currentPageItems.length > 0) {
          await renderPage(doc, currentPageItems, pageWidthPx, pageHeightPx, pdfConfig.margin, fileName, pageTotal);
        }

        // 13. 保存 PDF
        doc.save(`${fileName}.pdf`);
        resolve({
          code: 200
        })
      } catch (error) {
        reject({
          code: 500,
          message: error.message
        })
      }
    }, 500);
  });
}

function createTempDiv(element) {
  const tempDiv = document.createElement('div');
  tempDiv.style.width = `${852}px`;
  tempDiv.style.position = 'absolute';
  tempDiv.style.top = '-9999px';
  tempDiv.style.left = '-9999px';
  tempDiv.appendChild(element.cloneNode(true));
  document.body.appendChild(tempDiv);
  return tempDiv;
}

// 等待元素内所有资源（图片、背景图）加载完成
async function waitForResources(element) {
  // 等待 <img> 标签加载
  const imgPromises = Array.from(element.querySelectorAll('img')).map(img => {
    if (img.complete) return Promise.resolve();
    return new Promise(resolve => {
      img.onload = resolve;
      img.onerror = resolve; // 忽略加载失败
    });
  });

  // 等待背景图加载
  const bgImgPromises = Array.from(element.querySelectorAll('*')).map(el => {
    const style = window.getComputedStyle(el);
    const bgImg = style.backgroundImage;
    if (bgImg === 'none') return Promise.resolve();
    const img = new Image();
    img.src = bgImg.replace(/^url\(['"]?|['"]?\)$/g, '');
    if (img.complete) return Promise.resolve();
    return new Promise(resolve => {
      img.onload = resolve;
      img.onerror = resolve;
    });
  });

  await Promise.all([...imgPromises, ...bgImgPromises]);
}

// 渲染单页并添加到 PDF
async function renderPage(doc, items, pageWidthPx, pageHeightPx, marginMm, fileName, pageTotal) {
  const tempPage = document.createElement('div');
  tempPage.style.width = `${852}px`;
  tempPage.style.height = `${pageHeightPx}px`;
  tempPage.style.overflow = 'hidden';

  tempPage.style.transform = `scale(0.82)`;

  items.forEach(item => tempPage.appendChild(item));
  document.body.appendChild(tempPage);

  // 渲染为 canvas
  const canvas = await html2canvas(tempPage, {
    scale: 2,
    width: pageWidthPx,
    height: pageHeightPx,
    useCORS: true,
    logging: false,
    ignoreElements: function(element) { 
      const style = window.getComputedStyle(element);
      return style.visibility == 'hidden' || element.classList.contains('topright') || style.display == 'none' || style.opacity == '0'
    }
  });

  document.body.removeChild(tempPage);

  // 转换为图片并添加到 PDF
  const imgData = canvas.toDataURL('image/jpeg', 0.95);
  doc.addImage(
    imgData,
    'JPEG',
    marginMm,
    marginMm,
    pageWidthPx / 3.78, // 转换为 mm
    pageHeightPx / 3.78 // 转换为 mm
  );

  drawHeader(doc, fileName, pageTotal);
}

function drawHeader(pdf, fileName, pageTotal) {
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const headerYPosition = 8; // 页眉在页面上的 Y 坐标 (距离顶部 20pt)

  // 起始位置
  let startX = 0;
  // 距离两边的边距
  let pagePadding = 12;
  // 设置页眉字体样式
  pdf.setFontSize(10);
  // 设置字体样色
  pdf.setTextColor(38);
  // 绘制页眉
  pdf.text(fileName, startX + pagePadding, headerYPosition, { align: "left" });

  pdf.setFontSize(10);
  // pdf.setTextColor(232, 234, 237);
  pdf.text(`第 ${ pageTotal } 页`, pageWidth / 2, pageHeight - 3, { align: "center" });

  const offsetToTop = 5;
  // 设置线颜色
  pdf.setDrawColor(0, 0, 0, 0.06);
  // 设置线宽
  pdf.setLineWidth(0.1);
  pdf.line(
    startX + pagePadding,                      // 线的起点 x
    headerYPosition + offsetToTop,  // 线的起点 y
    startX + pageWidth - pagePadding,          // 线的终点 x
    headerYPosition + offsetToTop  // 线的终点 y
  );
}

/**
 * 计算给定日期前 n 天的日期
 * @param {string} dateStr - 给定的日期字符串，格式为 'YYYY-MM-DD'
 * @param {number} n - 要减去的天数
 * @returns {string} - 计算出的日期字符串，格式为 'YYYY-MM-DD'
 */
function getDateBefore(dateStr, n) {
  // 1. 将日期字符串转换为 Date 对象
  const date = new Date(dateStr);

  // 2. 检查日期是否有效
  if (isNaN(date.getTime())) {
    throw new Error("无效的日期格式，请使用 'YYYY-MM-DD' 格式");
  }

  // 3. 计算前 n 天的时间戳
  // getTime() 返回日期的毫秒数，一天的毫秒数是 86400000
  const timeStamp = date.getTime() - n * 24 * 60 * 60 * 1000;

  // 4. 根据时间戳创建新的 Date 对象
  const previousDate = new Date(timeStamp);

  // 5. 格式化日期为 'YYYY-MM-DD' 格式
  const year = previousDate.getFullYear();
  const month = String(previousDate.getMonth() + 1).padStart(2, '0');
  const day = String(previousDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}


/**
 * 将节点及其所有子节点的class样式转为行内样式（仅转class定义属性，合并已有行内样式）
 * @param {Element} element - 要转换的DOM元素
 */
function convertClassToInlineStyles(element) {
  if (!element || !(element instanceof HTMLElement)) return;

  // 处理自身及所有子节点
  const allElements = [element, ...element.querySelectorAll('*')];

  allElements.forEach(el => {
    // 跳过已有大量行内样式的元素（保留原逻辑）
    if (el.style.cssText && el.style.cssText.length > 100) return;

    // 1. 获取class中实际定义的样式（去重、按优先级合并）
    const classStyles = getClassDefinedStyles(el);
    if (Object.keys(classStyles).length === 0) return;

    // 2. 获取已有行内样式（解析为键值对，保留优先级）
    const inlineStyles = parseInlineStyles(el);

    // 3. 合并样式：行内样式优先级 > class样式（不覆盖已有行内样式）
    const mergedStyles = { ...classStyles, ...inlineStyles };

    // 4. 构建并设置最终行内样式
    const styleText = Object.entries(mergedStyles)
      .map(([prop, value]) => `${prop}: ${value};`)
      .join(' ');

    el.style.cssText = styleText;
  });
}

/**
 * 解析元素已有行内样式为键值对（保留!important）
 * @param {HTMLElement} el - 目标元素
 * @returns {Record<string, string>} 行内样式键值对
 */
function parseInlineStyles(el) {
  const styles = {};
  if (!el.style.cssText) return styles;

  el.style.cssText.split(';').forEach(declaration => {
    const [propPart, valuePart] = declaration.trim().split(':').map(item => item.trim());
    if (!propPart || !valuePart) return;

    // 提取!important标记
    const hasImportant = valuePart.includes('!important');
    const value = hasImportant 
      ? valuePart.trim() 
      : valuePart.trim();
    const prop = propPart.toLowerCase(); // 统一属性名为小写（避免大小写冲突）

    styles[prop] = value;
  });
  return styles;
}

/**
 * 提取元素class中实际定义的所有样式（排除默认值，按CSS优先级合并）
 * @param {HTMLElement} el - 目标元素
 * @returns {Record<string, string>} class样式键值对（含!important）
 */
function getClassDefinedStyles(el) {
  const classList = Array.from(el.classList);
  if (classList.length === 0) return {};

  // 获取所有匹配当前元素的class相关CSS规则（含媒体查询生效规则）
  const matchedRules = getMatchedClassRules(el, classList);
  const classStyles = {};

  // 按规则优先级合并：后匹配的规则覆盖前序规则（符合CSS渲染逻辑）
  matchedRules.forEach(rule => {
    const ruleStyle = rule.style;
    for (let i = 0; i < ruleStyle.length; i++) {
      const prop = ruleStyle[i]; // 标准属性名（小写）
      const value = ruleStyle.getPropertyValue(prop);
      const priority = ruleStyle.getPropertyPriority(prop); // 获取!important
      const fullValue = priority ? `${value.trim()} !important` : value.trim();

      // 排除默认值（仅保留class自定义的属性）
      if (value && !isDefaultValue(prop, fullValue, el.tagName)) {
        classStyles[prop] = fullValue;
      }
    }
  });

  return classStyles;
}

/**
 * 获取应用到元素且与class相关的CSS规则（兼容浏览器，处理媒体查询）
 * @param {HTMLElement} el - 目标元素
 * @param {string[]} classList - 元素class列表
 * @returns {CSSStyleRule[]} 匹配的CSS规则数组
 */
function getMatchedClassRules(el, classList) {
  // 优先使用原生方法（精准匹配所有应用规则）
  try {
    if (el.getMatchedCSSRules) {
      return Array.from(el.getMatchedCSSRules())
        .filter(rule => isClassRelatedRule(rule, classList));
    }
  } catch (e) {
    console.warn('原生方法不支持，降级手动匹配:', e);
  }

  // 降级方案：遍历所有样式表，匹配class相关且生效的规则
  return collectClassRulesManually(el, classList);
}

/**
 * 判断CSS规则是否与元素class相关（选择器包含元素的class）
 * @param {CSSRule} rule - CSS规则
 * @param {string[]} classList - 元素class列表
 * @returns {boolean} 是否相关
 */
function isClassRelatedRule(rule, classList) {
  if (rule.type !== CSSRule.STYLE_RULE) return false;

  const selector = rule.selectorText.toLowerCase();
  return classList.some(cls => selector.includes(`.${cls.toLowerCase()}`));
}

/**
 * 手动遍历样式表，收集匹配的class规则（处理媒体查询、跨域）
 * @param {HTMLElement} el - 目标元素
 * @param {string[]} classList - 元素class列表
 * @returns {CSSStyleRule[]} 匹配的规则数组
 */
function collectClassRulesManually(el, classList) {
  const matchedRules = [];

  Array.from(document.styleSheets).forEach(styleSheet => {
    try {
      if (!styleSheet.cssRules) return; // 跳过跨域样式表（无权限访问规则）

      Array.from(styleSheet.cssRules).forEach(rule => {
        // 处理媒体查询规则：仅保留当前生效的
        if (rule.type === CSSRule.MEDIA_RULE) {
          if (window.matchMedia(rule.media.mediaText).matches) {
            Array.from(rule.cssRules).forEach(mediaRule => {
              if (isClassRelatedRule(mediaRule, classList) && el.matches(mediaRule.selectorText)) {
                matchedRules.push(mediaRule);
              }
            });
          }
        }
        // 处理普通样式规则
        else if (rule.type === CSSRule.STYLE_RULE) {
          if (isClassRelatedRule(rule, classList) && el.matches(rule.selectorText)) {
            matchedRules.push(rule);
          }
        }
      });
    } catch (e) {
      console.warn(`跳过跨域样式表: ${styleSheet.href}`, e);
    }
  });

  return matchedRules;
}

/**
 * 精准判断属性是否为浏览器默认值（按标签名区分）
 * @param {string} property - CSS属性名
 * @param {string} value - 属性值（含!important）
 * @param {string} tagName - 元素标签名（大写）
 * @returns {boolean} 是否为默认值
 */
function isDefaultValue(property, value, tagName) {
  // 移除!important标记（默认值无!important）
  const pureValue = value.replace(/\s+!important$/, '').trim();

  // 不同标签的默认样式映射（可根据需求扩展）
  const tagDefaults = {
    DIV: { display: 'block', position: 'static', width: 'auto', height: 'auto', color: 'rgb(0, 0, 0)', 'background-color': 'rgba(0, 0, 0, 0)', margin: '0px', padding: '0px', border: '0px none rgb(0, 0, 0)' },
    SPAN: { display: 'inline', position: 'static', width: 'auto', height: 'auto', color: 'rgb(0, 0, 0)', 'background-color': 'rgba(0, 0, 0, 0)', margin: '0px', padding: '0px', border: '0px none rgb(0, 0, 0)' },
    H1: { display: 'block', position: 'static', width: 'auto', height: 'auto', color: 'rgb(0, 0, 0)', 'background-color': 'rgba(0, 0, 0, 0)', margin: '0.67em 0', padding: '0px', border: '0px none rgb(0, 0, 0)', 'font-weight': 'bold' },
    INPUT: { display: 'inline-block', position: 'static', width: 'auto', height: 'auto', color: 'rgb(0, 0, 0)', 'background-color': 'rgb(255, 255, 255)', margin: '0px', padding: '1px 2px', border: '1px solid rgb(169, 169, 169)' },
    BUTTON: { display: 'inline-block', position: 'static', width: 'auto', height: 'auto', color: 'rgb(0, 0, 0)', 'background-color': 'rgb(239, 239, 239)', margin: '0px', padding: '1px 6px', border: '1px solid rgb(169, 169, 169)' }
  };

  // 无对应标签时使用通用默认值
  const defaults = tagDefaults[tagName] || {
    display: 'inline', position: 'static', width: 'auto', height: 'auto',
    color: 'rgb(0, 0, 0)', 'background-color': 'rgba(0, 0, 0, 0)', padding: '0px', border: '0px none rgb(0, 0, 0)'
  };

  return defaults[property] === pureValue;
}